var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c("v-data-table", {
        staticStyle: { "white-space": "nowrap" },
        attrs: {
          headers: _vm.headers,
          items: _vm.items,
          "hide-default-header": _vm.empty,
          height: _vm.items.length > 7 ? 32 * 7 + 32 + 16 : undefined,
          "item-key": "none",
          "disable-pagination": "",
          "hide-default-footer": "",
          dense: "",
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function () {
              return [
                _c(
                  "v-toolbar",
                  { attrs: { flat: "", dense: "" } },
                  [
                    _c("v-toolbar-title", [_vm._v(_vm._s(_vm.title))]),
                    _c("v-divider", {
                      staticClass: "mx-2",
                      attrs: { inset: "", vertical: "" },
                    }),
                    _c(
                      "v-menu",
                      {
                        attrs: {
                          absolute: false,
                          "close-on-click": true,
                          "close-on-content-click": true,
                          "offset-y": "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "activator",
                            fn: function ({ on }) {
                              return [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    {
                                      staticClass: "ma-2",
                                      attrs: { color: "primary" },
                                    },
                                    on
                                  ),
                                  [
                                    _vm._v(" ADD "),
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "ml-2",
                                        attrs: { small: "" },
                                      },
                                      [_vm._v("mdi-text-box")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      },
                      [
                        _c(
                          "v-sheet",
                          { attrs: { "max-height": "600" } },
                          [
                            _c(
                              "v-list",
                              { staticClass: "pa-0", attrs: { dense: "" } },
                              _vm._l(_vm.sortedKinds, function (kind, i) {
                                return _c(
                                  "v-list-item",
                                  {
                                    key: kind + i,
                                    attrs: { dense: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.row_create(kind)
                                      },
                                    },
                                  },
                                  [
                                    _c("v-list-item-title", {
                                      domProps: {
                                        textContent: _vm._s(kind.name),
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("v-spacer"),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "item.actions",
            fn: function ({ item }) {
              return [
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: { small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.row_update(item)
                      },
                    },
                  },
                  [_vm._v("mdi-pencil")]
                ),
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: { small: "", color: "teal lighten-1" },
                    on: {
                      click: function ($event) {
                        return _vm.row_copy(item)
                      },
                    },
                  },
                  [_vm._v(" mdi-content-copy ")]
                ),
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: { small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.row_moveup(item)
                      },
                    },
                  },
                  [_vm._v("mdi-arrow-up-thick")]
                ),
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: { small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.row_movedown(item)
                      },
                    },
                  },
                  [_vm._v("mdi-arrow-down-thick")]
                ),
                _c(
                  "v-icon",
                  {
                    staticClass: "mr-2",
                    attrs: { small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.row_remove(item)
                      },
                    },
                  },
                  [_vm._v("mdi-delete")]
                ),
              ]
            },
          },
        ]),
      }),
      _c("r-smart-offer-bundle-shop", { ref: "dialog_1" }),
      _c("r-smart-offer-bundle-firefly", { ref: "dialog_2" }),
      _c("r-smart-offer-bundle-achievement", { ref: "dialog_3" }),
      _c("r-smart-offer-bundle-market", { ref: "dialog_4" }),
      _c("r-smart-offer-bundle-cascade", { ref: "dialog_5" }),
      _c("r-smart-offer-bundle-treasure", { ref: "dialog_6" }),
      _c("r-smart-offer-bundle-energy-refill", { ref: "dialog_7" }),
      _c("r-smart-offer-bundle-progressive", { ref: "dialog_8" }),
      _c("r-smart-offer-bundle-master-season", { ref: "dialog_9" }),
      _c("r-smart-offer-bundle-sunken-ruins", { ref: "dialog_10" }),
      _c("r-smart-offer-bundle-ancient-treasure", { ref: "dialog_11" }),
      _c("r-smart-offer-bundle-collection", { ref: "dialog_12" }),
      _c("r-smart-offer-bundle-daily-pass", { ref: "dialog_13" }),
      _c("r-smart-offer-bundle-decoration", { ref: "dialog_14" }),
      _c("r-smart-offer-bundle-hidden-temple", { ref: "dialog_15" }),
      _c("r-smart-offer-bundle-alchemy", { ref: "dialog_16" }),
      _c("r-smart-offer-bundle-time-limited", { ref: "dialog_17" }),
      _c("r-smart-offer-bundle-any-purchase", { ref: "dialog_18" }),
      _c("r-smart-offer-bundle-multi-tab", { ref: "dialog_19" }),
      _c("r-smart-offer-bundle-treasure-achievement", { ref: "dialog_20" }),
      _c("r-smart-offer-bundle-plinko", { ref: "dialog_21" }),
      _c("r-smart-offer-bundle-magic-spin", { ref: "dialog_22" }),
      _c("r-smart-offer-bundle-treasure-shop", { ref: "dialog_23" }),
      _c("r-smart-offer-bundle-treasure-offer", { ref: "dialog_24" }),
      _c("r-smart-offer-bundle-plinko-shop-simple", { ref: "dialog_25" }),
      _c("r-smart-offer-bundle-plinko-shop-double", { ref: "dialog_26" }),
      _c("r-smart-offer-bundle-one-plus-two", { ref: "dialog_27" }),
      _c("r-smart-offer-bundle-card-box-bank", { ref: "dialog_28" }),
      _c("r-smart-offer-bundle-expd-treasure-gate", { ref: "dialog_29" }),
      _c("r-smart-offer-bundle-expd-treasure-tree", { ref: "dialog_30" }),
      _c("r-smart-offer-bundle-novice-battle-pass", { ref: "dialog_31" }),
      _c("r-smart-offer-bundle-piggy", { ref: "dialog_32" }),
      _c("r-smart-offer-bundle-reward-giver", { ref: "dialog_33" }),
      _c("r-smart-offer-bundle-christmas-hub", { ref: "dialog_34" }),
      _c("r-smart-offer-bundle-christmas-calendar", { ref: "dialog_35" }),
      _c("r-smart-offer-bundle-christmas", { ref: "dialog_36" }),
      _c("r-smart-offer-bundle-expedition-group", { ref: "dialog_37" }),
      _c("r-smart-offer-bundle-flash-ad", { ref: "dialog_38" }),
      _c("r-smart-offer-bundle-magical-cinema", { ref: "dialog_39" }),
      _c("r-smart-offer-bundle-hub", { ref: "dialog_40" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }